let filter;
if(document.querySelector(".snippet-collection-filter")){
  filter = document.querySelector(".snippet-collection-filter").offsetHeight;
}
var lastScroll = 0;
window.addEventListener('scroll',(e) => {
  let scrollCount = window.pageYOffset;
  if(document.querySelector('body.collection') || document.querySelector('body.template-search')){
    let header = document.querySelector('.header-group');
    // if(scrollCount >= header.offsetHeight){
    //   document.body.style.setProperty("--header-height",`${header.offsetHeight}px`);
    //   if(window.innerWidth > 991){
    //     document.querySelector('.header-group-wrap').style.height = header.offsetHeight+'px';
    //     header.style.top = '-'+header.offsetHeight+'px';
    //     header.classList.add('is-fixed');
    //   }
    // }else{
    //   header.classList.remove('is-fixed');
    // }
  let filterWrapper;
    filterWrapper = document.querySelector('.snippet-collection-filter');
  if(filterWrapper && scrollCount >= filterWrapper.scrollHeight){
      document.body.classList.add('sticky-filter');
      if(document.querySelector('.collection-filter')) document.querySelector('.collection-filter').style.height = document.querySelector('.collection-filter').offsetHeight+'px';
      // if(document.querySelector('.collection-filter')) document.querySelector('.collection-filter').style.height = document.querySelector('.snippet-collection-filter').offsetHeight+'px';
    }else{
      document.body.classList.remove('sticky-filter','open-subcoll');
    }
    if(document.querySelector('body').classList.contains('open-filter')){
      (scrollCount >= filter) ? document.querySelector('body').classList.add('sticky-filter') : document.querySelector('body').classList.remove('sticky-filter')
    }
    let main_header = document.querySelector('.main-header');
    if(scrollCount > 0){
      main_header.classList.add('sticky_header');
    }else{
      main_header.classList.remove('sticky_header');
    }
  }
  setTimeout(function(){
    if(scrollCount > lastScroll){
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    }else if(scrollCount < lastScroll){
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
      if(scrollCount <= 0){
        if(document.querySelector('.collection-filter')){
          document.querySelector('.collection-filter').style.height = '';
          document.querySelector('.collection-filter').style.height = document.querySelector('.collection-filter').offsetHeight+'px';
        }
      }
    }
    lastScroll = scrollCount;
  }, 0);
})
// if(document.querySelectorAll('.mega-link')) document.querySelectorAll('.mega-link').forEach(function(main_nav){
//   main_nav.addEventListener('click',function(e){
//     e.preventDefault();
//     document.body.classList.add('menu-link-clicked');
//     document.querySelectorAll('.mega-link').forEach(function(main_nav_remove){
//       main_nav_remove.closest('li').classList.remove('active-link');
//     });
//     main_nav.closest('li').classList.add('active-link');
//     let main_label = main_nav.closest('li').dataset.val;
//     document.querySelectorAll('.sub-nav-inr').forEach(function(sub_nav){
//       let sub_label = sub_nav.dataset.val;
//       document.body.classList.add('open-second-level');
//       document.body.classList.add('hide-second-back');
//       if(sub_label == main_label){
//         document.querySelectorAll('.sub-nav-inr').forEach(function(sub_nav_remove){
//           sub_nav_remove.classList.remove('active-link');
//         });
//         sub_nav.classList.add('active-link');
//       }else{
//         sub_nav.classList.remove('active-link');
//       }
//     });
//   });
// });
document.querySelectorAll('.mega-link').forEach(function(main_nav){
  function handleEvent(e){
    // console.log('enter',e.target);
    if(window.innerWidth <= 991){
      e.preventDefault();
    }
    document.body.classList.remove('out-animate');
    document.body.classList.add('in-animate');
    document.body.classList.add('menu-link-clicked');
    document.body.classList.add('main-menu-clicked');
    document.querySelectorAll('.mega-link').forEach(main_nav_remove => {
      main_nav_remove.closest('li').classList.remove('active-link');
    });
    main_nav.closest('li').classList.add('active-link');
    let main_label = main_nav.closest('li').dataset.val;
    // setTimeout(() => {
    document.body.classList.add('open-second-level');
    // document.body.classList.add('open-second-level', 'hide-second-back');
    // }, 1000);
    document.querySelectorAll('.sub-nav-inr').forEach(sub_nav => {
      let sub_label = sub_nav.dataset.val;
      sub_nav.classList.toggle('active-link', sub_label === main_label);
    });
  }
  main_nav.addEventListener('click', handleEvent);
  main_nav.addEventListener('mouseenter', handleEvent);
});
if(document.querySelectorAll('.md-mega-close')) document.querySelectorAll('.md-mega-close').forEach(function(mega_close){
  mega_close.addEventListener('click',function(e){
    e.preventDefault();
    document.body.classList.remove('open-menu','open-second-level','main-menu-clicked','out-animate');
  });
});
if (document.querySelectorAll('.md-mega-back')) {
  document.querySelectorAll('.md-mega-back').forEach(function (nav_back) {
    nav_back.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.classList.add('out-animate');
      document.body.classList.remove('in-animate');

      setTimeout(() => {
        const activeLink = document.querySelector('.main-nav li.active-link');
        if (activeLink) {
          activeLink.classList.remove('active-link');
        }

        const firstNavItem = document.querySelectorAll('.main-nav li')[0];
        if (firstNavItem) {
          firstNavItem.classList.add('active-link');
        }

        // Ensure the first visible item gets the active-link class
        const activeLinks = document.querySelectorAll('.active-link');
        activeLinks.forEach((activeLink) => {
          if (activeLink.offsetParent === null) {
            const parentList = activeLink.closest('ul, .sub-nav, .second-nav');
            if (parentList) {
              const firstVisibleItem = Array.from(parentList.children).find(
                (item) => item.offsetParent !== null
              );

              if (firstVisibleItem) {
                activeLink.classList.remove('active-link');
                firstVisibleItem.classList.add('active-link');
              }
            }
          }
        });

        document.body.classList.remove('open-second-level', 'main-menu-clicked');
      }, 200);
    });
  });
}
if(document.querySelectorAll('.search-close')) document.querySelectorAll('.search-close').forEach(function(searchClose){
  searchClose.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.snippet-search-bar').classList.remove('active-search-results');
    document.querySelector('.search-wrapper').classList.remove('active');
    const searchInput = document.querySelector('.snippet-search-bar input');
    searchInput.value = '';
    searchInput.focus();
  }); 
});
if(document.querySelectorAll('.mobile-search')) document.querySelectorAll('.mobile-search').forEach(searchButton => {
  const toggleSearch = (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    document.querySelector('.snippet-search-bar input').value = '';
    document.body.classList.toggle(window.innerWidth > 991 ? 'open-search' : 'open-mobile-search');
    document.body.classList.remove('open-drawer', 'open-sort', 'open-filter');
    document.querySelector(".snippet-search-bar predictive-search #Search").focus();
  };
  searchButton.addEventListener('click', toggleSearch);
  searchButton.addEventListener('touchstart', toggleSearch);
});
function header_click(){
  if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
    menuBurger.addEventListener('click',function(e){
      if(window.innerWidth < 991 && typeof preventScroll !== 'undefined'){
        preventScroll.enable();
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      if(window.innerWidth > 991){
        if(document.body.classList.contains('open-search') || document.body.classList.contains('open-mobile-search')){
          document.body.classList.remove('open-mobile-search');
        }else if(document.body.classList.contains('active-acc') && !document.body.classList.contains('open-menu')){
          document.body.classList.remove('active-acc');
        }else{
          document.body.classList.toggle('open-menu');
        }
      }else{
        if(document.body.classList.contains('open-search') || document.body.classList.contains('open-mobile-search') || document.body.classList.contains('active-acc')){
          document.body.classList.remove('open-mobile-search','active-acc');
        }else{
          document.body.classList.toggle('open-menu');
        }
      }
      document.body.classList.remove('open-drawer','open-search','open-sort','open-filter','menu-link-clicked');
      
      // Update aria-label and aria-expanded for accessibility
      const isOpen = document.body.classList.contains('open-menu');
      if(this.classList.contains('menu-burdger')){
        this.setAttribute('aria-label', isOpen ? 'Close menu' : 'Menu');
        this.setAttribute('aria-expanded', isOpen);
      }
    });
  });
}
header_click();
if(document.querySelectorAll('.menu-burdger')) document.querySelectorAll('.menu-burdger').forEach(burger => {
  let n = false;
  burger.addEventListener('mouseenter', function(){
    if(!n){
      n = true;
      gsap.timeline()
        .to(this.querySelectorAll('.menu-burdger-icon span'), {
          scaleX: 0,
          duration: 0.4,
          stagger: 0.06,
          transformOrigin: "right top",
          ease: "expo.in",
          x: 1, y: 1,
        })
        .to(this.querySelectorAll('.menu-burdger-icon span'), {
          delay: 0.4,
          scaleX: 1,
          duration: 0.8,
          stagger: 0.06,
          transformOrigin: "left top",
          ease: "expo.out",
          x: 1, y: 1,
          onComplete: () => {
            n = false;
          }
        }, 0);
    }
  });
  burger.addEventListener('mouseleave', function(){
    if(!n){
      n = true;
      gsap.timeline()
        .to(this.querySelectorAll('.menu-burdger-icon span'), {
          scaleX: 1,
          duration: 0.4,
          stagger: 0.06,
          transformOrigin: "right top",
          ease: "expo.in",
          x: 1, y: 1,
        })
        .to(this.querySelectorAll('.menu-burdger-icon span'), {
          delay: 0.4,
          scaleX: 1,
          duration: 0.8,
          stagger: 0.06,
          transformOrigin: "left top",
          ease: "expo.out",
          x: 1, y: 1,
          onComplete: () => {
            n = false;
          }
        }, 0);
    }
  });
});
document.addEventListener('click', function(e){
  let subLevel = document.querySelectorAll('body.open-menu .search-wrapper,#Search');
  let isInsideClick = false;
  subLevel.forEach(function(element){
    if (element.contains(e.target) || element === e.target) isInsideClick = true;
  });
  if(!isInsideClick){
    document.body.classList.remove('open-search','open-mobile-search');
  }
});
function renderWishlistCounter(swat){  
  var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter");
  if(counter_elem){
    for(var i = 0; i < counter_elem.length; i++){
      if(swat.renderWishlistCount){
        swat.renderWishlistCount(counter_elem[i], function(count, element){});
      }
    }
  }
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderWishlistCounter);

document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector('.header-group');
  if(header){
    document.body.style.setProperty("--header-height", `${header.offsetHeight}px`);
  }
  const activeLinks = document.querySelectorAll(".active-link");

  activeLinks.forEach((activeLink) => {
    // Check if the active-link is hidden
    if (activeLink.offsetParent === null) {
      // Find the first visible item in the same list
      const parentList = activeLink.closest("ul, .sub-nav, .second-nav");
      if (parentList) {
        const firstVisibleItem = Array.from(parentList.children).find(
          (item) => item.offsetParent !== null
        );

        // Add the active-link class to the first visible item
        if (firstVisibleItem) {
          activeLink.classList.remove("active-link");
          firstVisibleItem.classList.add("active-link");
        }
      }
    }
  });
});